/**
 * TerminosCondicionesPage component
 * @returns <TerminosCondicionesPage />
 */
import Breadcrumbs from "../components/Breadcrumbs"
import Accordion from "../components/Accordion"
import { useGetTerminosCondicionesDataQuery } from "../redux/apiSlice";
import { AnimatePresence } from "framer-motion";
import Loader from "../components/Loader";
import { useLocation } from "react-router-dom";

const PrivacidadLegalesPage = () => {
    const location = useLocation();

    const BreadcrumbsProps = {
        links: [
            {
                link: "/",
                label: "Inicio"
            },
            {
                link: location.pathname,
                label: "Términos y condiciones"
            },
        ],
    }

    const {
        data,
        isLoading,
        isFetching,
        isSuccess,
        isError
    } = useGetTerminosCondicionesDataQuery();

    return (
        <>
            {isLoading && (
                <AnimatePresence>
                    <Loader />
                </AnimatePresence>
            )}
            {isSuccess && (
                <>
                    <Breadcrumbs {...BreadcrumbsProps} />
                    <section className="ayuda" style={{ backgroundColor: "white" }}>
                        <div className="wrapper">
                            <h1>{data.title}</h1>

                            <Accordion items={data.accordion.items} />
                        </div>
                    </section>
                </>
            )}
            {isError && <p>Hubo un error</p>}
        </>
    )
}

export default PrivacidadLegalesPage